var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-button"},[(_vm.type !== 'link')?_c('button',{staticClass:"c-button__button",class:{
      bg_red: _vm.bg_red,
      bg_white: _vm.bg_white,
      middle: _vm.middle,
      small: _vm.small,
      no_width: _vm.no_width,
      font_bold: _vm.font_bold,
      border_red: _vm.border_red,
      border_red_text_black: _vm.border_red_text_black,
      border_only_red: _vm.border_only_red,
      border_gray: _vm.border_gray,
      icon: _vm.icon,
      display: _vm.display,
      width: _vm.width,
      tablet_width: _vm.tablet_width,
      sp_width: _vm.sp_width,
      font_size: _vm.font_size,
      color_red_text: _vm.color_red_text
    },style:(_vm.styles),attrs:{"disabled":_vm.disabled,"type":_vm.submit_type ? 'submit': 'button'},on:{"click":function($event){_vm.callback ? _vm.callback(_vm.attr[0]) : function () {}}}},[(_vm.icon)?_c('img',{staticClass:"c-button__icon",attrs:{"src":require(("@/assets/images/" + _vm.icon + ".png")),"alt":""}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),(_vm.label)?_c('span',{staticClass:"c-button__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.type === 'link')?_c('a',{staticClass:"c-button__button",class:{
        bg_red: _vm.bg_red,
        bg_white: _vm.bg_white,
        middle: _vm.middle,
        small: _vm.small,
        no_width: _vm.no_width,
        font_bold: _vm.font_bold,
        border_red: _vm.border_red,
        border_red_text_black: _vm.border_red_text_black,
        border_only_red: _vm.border_only_red,
        border_gray: _vm.border_gray,
        icon: _vm.icon,
        display: _vm.display,
        width: _vm.width,
        tablet_width: _vm.tablet_width,
        sp_width: _vm.sp_width,
        font_size: _vm.font_size,
        color_red_text: _vm.color_red_text
      },style:(_vm.styles),attrs:{"href":_vm.link_url,"disabled":_vm.disabled,"target":_vm.target_blank ? '_blank': ''},on:{"click":function($event){return _vm.callback(_vm.attr[0])}}},[(_vm.icon)?_c('img',{staticClass:"c-button__icon",attrs:{"src":require(("@/assets/images/" + _vm.icon + ".png")),"alt":""}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),(_vm.label)?_c('span',{staticClass:"c-button__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }